import React from "react";

import { PlanoVinculadoService } from "../../services";
import { HomeAtivo } from "./HomeAtivo";
import { HomeAssistido } from "./HomeAssistido";
import { Page } from "..";
import { PlanoVinculadoEntidade } from "../../entidades";
import { Combo, Alerta, TipoAlerta } from "@intechprev/componentes-web";
import _ from "lodash";
import { BotaoInforme } from "../ComprovanteRendimentos/BotaoInforme";
import { HomePensionista } from "./HomePensionista";

interface Props { }

interface State {
  plano: PlanoVinculadoEntidade;
  planos: Array<PlanoVinculadoEntidade>;
  pensionista: boolean;
  sqPlanoPrevidencial: number;
  planosVazio: boolean;
}

export class Home extends React.Component<Props, State> {
  public page = React.createRef<Page>();
  public homeAtivo = React.createRef<HomeAtivo>();
  public homeAssistido = React.createRef<HomeAssistido>();

  constructor(props: Props) {
    super(props);

    this.state = {
      plano: new PlanoVinculadoEntidade(),
      planos: [],
      pensionista: localStorage.getItem("pensionista") === "true",
      sqPlanoPrevidencial: 0,
      planosVazio: false
    }
  }

  componentDidMount = async () => {
    var planos = await PlanoVinculadoService.Buscar();

    if (planos.length > 0) {
      var plano = planos[0];

      this.setState({
        planos,
        plano,
        sqPlanoPrevidencial: plano.SQ_PLANO_PREVIDENCIAL
      });
    } else {
      this.setState({
        planosVazio: true
      })
    }
  }

  carregarPlano = async () => {
    var planoSelecionado = null;
    var sqPlanoPrevidencial = parseInt(this.state.sqPlanoPrevidencial.toString());

    if (this.state.sqPlanoPrevidencial)
      planoSelecionado = _.filter(this.state.planos, (plano: any) => plano.SQ_PLANO_PREVIDENCIAL === sqPlanoPrevidencial)[0];
    else
      planoSelecionado = this.state.planos[0];

    sqPlanoPrevidencial = planoSelecionado.SQ_PLANO_PREVIDENCIAL;

    if (planoSelecionado.SQ_SIT_PLANO === 1 || this.state.plano.SQ_SIT_PLANO === 5 || this.state.plano.SQ_SIT_PLANO === 9)
      this.homeAtivo.current.carregarDados(planoSelecionado);
    else
      this.homeAssistido.current.carregarDados(planoSelecionado);

    this.setState({
      plano: planoSelecionado,
      sqPlanoPrevidencial
    });
  }

  render() {
    return (
      <Page {...this.props} ref={this.page}>
        {/* {this.state.plano.SQ_SIT_PLANO === 3 &&
                    <BotaoInforme />
                } */}

        {this.state.planos.length > 1 &&
          <Combo contexto={this} titulo={"Selecione um plano"} onChange={this.carregarPlano}
            nome={"sqPlanoPrevidencial"} valor={this.state.sqPlanoPrevidencial} obrigatorio
            opcoes={this.state.planos} nomeMembro={"DS_PLANO_PREVIDENCIAL"} valorMembro={"SQ_PLANO_PREVIDENCIAL"} />
        }

        {this.state.pensionista &&
          <HomePensionista {...this.props} />
        }

        {(this.state.plano.SQ_SIT_PLANO === 1 || this.state.plano.SQ_SIT_PLANO === 4 || this.state.plano.SQ_SIT_PLANO === 5 || this.state.plano.SQ_SIT_PLANO === 9) &&
          <HomeAtivo ref={this.homeAtivo} {...this.props} page={this.page} plano={this.state.plano} />
        }

        {this.state.plano.SQ_SIT_PLANO === 3 &&
          <HomeAssistido ref={this.homeAssistido} {...this.props} page={this.page} plano={this.state.plano} />
        }

        {this.state.planosVazio &&
          <Alerta tipo={TipoAlerta.danger} mensagem={"Nenhum plano válido foi encontrado! Entre em contato com a EQTPREV."} />
        }
      </Page>
    );
  }
}